import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { PessoaEnderecoModule } from '../../../pessoa/endereco';
import { LeadContatoModule } from '../contato';
import { LeadEnderecoComponent } from './lead-endereco.component';
import { LeadEnderecoFormComponent } from './form';
import { LeadEnderecoUnicoComponent } from './unico';

@NgModule({
    imports: [
        SharedModule,
        PessoaEnderecoModule,
        LeadContatoModule
    ],
    declarations: [
        LeadEnderecoComponent,
        LeadEnderecoFormComponent,
        LeadEnderecoUnicoComponent,
    ],
    exports: [
        LeadEnderecoComponent,
        LeadEnderecoUnicoComponent
    ]
})
export class LeadEnderecoModule { }
